module.exports = __webpack_public_path__ + "static/media/key.584a68b0.svg";